import { render } from "./PurchaseMahadashaAnalysisReport.vue?vue&type=template&id=b4a27984&scoped=true"
import script from "./PurchaseMahadashaAnalysisReport.vue?vue&type=script&lang=js"
export * from "./PurchaseMahadashaAnalysisReport.vue?vue&type=script&lang=js"

import "./PurchaseMahadashaAnalysisReport.vue?vue&type=style&index=0&id=b4a27984&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a27984"]])

export default __exports__